<template>
  <el-dialog
    :title="dialogType === 'create' ? 'EAN hozzáadása' : 'EAN szerkesztése'"
    :append-to-body="true"
    :visible="visible"
    :close-on-click-modal="false"
    width="350px"
    @open="onOpen"
    @close="$emit('close')"
  >
    <el-form
      v-loading="loading"
      ref="form"
      :model="item"
      label-position="top"
    >
      <el-form-item
        label="EAN kód"
      >
        <el-input
          v-model="item.ean"
        />
      </el-form-item>
      <el-form-item
        label="Beszállító"
      >
        <el-select
          v-model="item.supplier_id"
          v-loading="suppliersLoading"
          filterable
          style="width: 100%;"
          @change="setSupplier"
        >
          <el-option
            v-for="s in suppliers"
            :key="s.id"
            :value="s.id"
            :label="s.name"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="store">{{ dialogType === 'create' ? 'Hozzáadás' : 'Mentés'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import measureUnits from '../../measureUnits';

export default {
  props: ['visible', 'currency', 'defaultItem', 'customerId'],
  data() {
    return {
      measureUnits,
      itemType: 'product',
      item: {
        unit_of_measure: 'PIECE'
      },
      dialogType: 'create',
      productsLoading: false,
      suppliersLoading: false,
      servicesLoading: false,
      packLoading: false,
      priceLoading: false,
      vatLoading: false,
      loading: false,
      originalUnitPrice: 0,
      products: [],
      services: [],
      suppliers: [],
      packTypes: [],
      vats: [],
    };
  },
  computed: {
    netPrice() {
      return this.item.unit_price * this.item.count;
    },
    grossPrice() {
      return this.netPrice * (1 + this.item.vat / 100);
    },
    priceTypes() {
      return this.$store.getters['priceType/priceTypes'];
    },
  },
  async mounted() {
    if (!this.priceTypes.length) {
      await this.$store.dispatch('priceType/fetchAll');
    }
    await this.setSuppliers();
  },
  methods: {
    async store() {
      this.item.supplier_name = this.item.supplier_id ? this.suppliers.find(partner => partner.id === this.item.supplier_id).name : null;
      this.$emit('change', this.item);
      this.$emit('close');
    },
    async setSuppliers() {
      this.suppliersLoading = true;
      const suppliers = await axios.get(`api/search/suppliers`);
      this.suppliers = suppliers;
      if (suppliers && suppliers.length) {
        this.$set(this.item, 'supplier_id', suppliers[0].id);
      }
      this.suppliersLoading = false;
    },
    setSupplier(value) {
      console.log(value);
    },
    async onOpen() {
      this.loading = true;
      this.setItem();
      if (this.item.key || this.item.id) {
        this.dialogType = 'update';
      } else {
        this.dialogType = 'create';
      }
      if (this.item.supplier_id) {
        this.suppliers = [{ id: this.item.supplier_id, name: this.item.supplier_name }];
      }
      this.loading = false;
    },
    setItem() {
      this.item = { ...this.defaultItem };
    },
    async search(resource, query) {
      if (query !== '') {
        this[`${resource}Loading`] = true;
        this[resource] = await axios.get(`api/search/${resource}${query}`);
        this[`${resource}Loading`] = false;
      }
    },
  },
};
</script>
